if (!customElements.get("pickup-availability")) {
	customElements.define(
		"pickup-availability",
		class PickupAvailability extends HTMLElement {
			constructor() {
				super();

				if (!this.hasAttribute("available")) return;

				this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
				this.onClickRefreshList = this.onClickRefreshList.bind(this);
				this.fetchAvailability(this.dataset.variantId, this.dataset.productHandle);
			}

			fetchAvailability(variantId, productHandle) {
				let rootUrl = this.dataset.rootUrl;
				if (!rootUrl.endsWith("/")) {
					rootUrl = rootUrl + "/";
				}
				const variantSectionUrl = `${rootUrl}products/${productHandle}/?section_id=pickup-availability&variant=${variantId}`;

				fetch(variantSectionUrl)
					.then((response) => response.text())
					.then((text) => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
						this.renderPreview(sectionInnerHTML);
					})
					.catch((_e) => {
						const button = this.querySelector("button");
						if (button) button.removeEventListener("click", this.onClickRefreshList);
						this.renderError();
					});
			}

			onClickRefreshList(_evt) {
				this.fetchAvailability(this.dataset.variantId, this.dataset.productHandle);
			}

			update(variant) {
				this.fetchAvailability(variant.id, this.dataset.productHandle);
			}

			renderError() {
				this.innerHTML = "";
				this.appendChild(this.errorHtml);

				this.querySelector("button").addEventListener("click", this.onClickRefreshList);
			}

			renderPreview(sectionInnerHTML) {
				const drawer = document.querySelector("pickup-availability-drawer");
				if (drawer) drawer.remove();
				if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
					return;
				}

				this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
				this.setAttribute("available", "");

				document.body.appendChild(sectionInnerHTML.querySelector("pickup-availability-drawer"));
			}
		}
	);
}

if (!customElements.get("pickup-availability-drawer")) {
	customElements.define(
		"pickup-availability-drawer",
		class PickupAvailabilityDrawer extends BasicModal {
			constructor() {
				super();
			}
			static get observedAttributes() {
				return ["open"];
			}
			attributeChangedCallback(name, oldValue, newValue) {
				if (name === "open" && (newValue === "" || newValue === "immediate")) {
					Shopify.analytics.publish("custom_pickup_availability", {
						event: "select_content",
						event_category: "store availability",
						event_action: "sharon",
						event_label: "paris 01",
					});
				}
				if (super.attributeChangedCallback) {
					super.attributeChangedCallback(name, oldValue, newValue);
				}
			}
		}
	);
}
